import SigliveServiceV1 from 'Service/sigliveServiceV1';

const getLiveAccount = async (queries = '') => {
  const { data } = await SigliveServiceV1({ method: 'GET', url: `/account-livestream/list?${queries}` });

  return data?.data;
};

export default getLiveAccount;
